import { FlexColumn } from '@elementary/common-ui/components';
import { SxProps, Typography } from '@mui/material';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { GPGKey, GPGKeyStatus } from '../types';
import GPGKeyStatusChip from './GPGKeyStatusChip';

const TypographyBody = ({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps;
}) => (
  <Typography variant="body2" sx={sx}>
    {children}
  </Typography>
);

const FingerprintTypography = styled(TypographyBody)`
  font-family: 'Geist Mono', monospace;
  font-size: 11px;
  word-break: break-all;
  margin-left: 1;
`;

const GPGKeyDetails = ({ gpgKey }: { gpgKey: GPGKey }) => (
  <FlexColumn sx={{ gap: 1 }}>
    <TypographyBody sx={{ fontWeight: 500 }}>Key Details:</TypographyBody>

    <FlexColumn sx={{ gap: 0.5, ml: 1 }}>
      <TypographyBody>
        <strong>Key ID:</strong> {gpgKey.keyId}
      </TypographyBody>
      <TypographyBody>
        <strong>Fingerprint:</strong>
      </TypographyBody>
      <FingerprintTypography>{gpgKey.fingerprint}</FingerprintTypography>
      <TypographyBody>
        <strong>Name:</strong> {gpgKey.keyName}
      </TypographyBody>
      <TypographyBody>
        <strong>Email:</strong> {gpgKey.keyEmail}
      </TypographyBody>
      <TypographyBody>
        <strong>Status:</strong> <GPGKeyStatusChip gpgKey={gpgKey} />
      </TypographyBody>

      {gpgKey.status !== GPGKeyStatus.revoked && (
        <>
          <TypographyBody>
            <strong>
              {gpgKey.expiresAt && dayjs(gpgKey.expiresAt).isBefore(dayjs())
                ? 'Expired on:'
                : 'Expires on:'}
            </strong>{' '}
            {gpgKey.expiresAt ? dayjs(gpgKey.expiresAt).format('L') : 'Never'}
          </TypographyBody>
        </>
      )}
    </FlexColumn>
  </FlexColumn>
);

export default GPGKeyDetails;
